var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.456,
    height: 88.72,
    viewBox: "0 0 71.456 88.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M802,709h31.223v31.249H802Zm0,0",
    transform: "translate(-802 -709)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M353.957,179h41.49v73h-41.49Zm0,0",
    transform: "translate(-353.957 -179)",
    fill: "#006297"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sans_titre_1920_1200_px_",
    "data-name": "Sans titre (1920\\xA0\\xD7\\xA01200\\xA0px)",
    transform: "translate(-353.957 -68.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M748.031,561.13a1.76,1.76,0,0,0-.832-.407,1.76,1.76,0,0,1,.832.407",
    transform: "translate(-357.93 -447.575)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M504.97,743.1v1.257c-1.562,0-3.087.014-4.612,0a.843.843,0,0,1-.809-.462c-.3-.545-.6-1.091-.91-1.631-.319-.582-.647-1.16-1.017-1.811-.083.152-.129.226-.166.3q-1.893,3.548-3.785,7.1a.938.938,0,0,1-.98.605.841.841,0,0,1-.887-.675c-1.1-3.054-2.213-6.117-3.313-9.167a.4.4,0,0,0-.189-.272c-.092.166-.176.3-.273.448-.971,1.631-1.95,3.266-2.921,4.9a.9.9,0,0,1-.8.522c-1.553.009-3.092,0-4.663,0v-1.257c1.174,0,2.306-.023,3.429.014a.761.761,0,0,0,.818-.416c1.243-2.116,2.518-4.223,3.776-6.339a.954.954,0,0,1,.971-.508.843.843,0,0,1,.836.628q1.546,4.29,3.1,8.562a2.2,2.2,0,0,0,.356.8c.092-.166.176-.3.259-.462,1.16-2.176,2.334-4.362,3.489-6.538a.455.455,0,0,0,.037-.083.907.907,0,0,1,.9-.522.918.918,0,0,1,.873.508c.767,1.4,1.562,2.791,2.329,4.186.134.24.273.333.652.333,1.174-.023,2.334-.014,3.5-.014",
    transform: "translate(-114.398 -606.84)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(394.19 126.463)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M828.155,718.981a2.179,2.179,0,0,0-.236.388,1.071,1.071,0,0,1-.143.24L817.72,733.3a1.558,1.558,0,0,1-1.091.628,1.621,1.621,0,0,1-.213.009,1.5,1.5,0,0,1-.98-.379l-7.324-6.316a1.859,1.859,0,0,1-.162-.175,1.889,1.889,0,0,0-.323-.319,2.037,2.037,0,0,1,.887-3.595,1.571,1.571,0,0,1,1.456.259,2.129,2.129,0,0,1,.485.425l4.889,4.223a.865.865,0,0,0,1.262-.143l7.93-10.8a.922.922,0,0,0,.153-.259,1.994,1.994,0,0,1,.684-.795,1.535,1.535,0,0,1,1.128-.356c.023,0,.046-.009.083-.009a2.041,2.041,0,0,1,1.571,3.276Zm-3.914-8.409a15.52,15.52,0,0,0-5.194-1.4,12.973,12.973,0,0,0-1.409-.06,15.617,15.617,0,0,0-15.629,15.612,15.857,15.857,0,0,0,.665,4.519,15.652,15.652,0,0,0,14.964,11.107,15.626,15.626,0,0,0,6.6-29.783",
    transform: "translate(-802.007 -709.107)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M481.862,357.134h-5.62v-5.618h5.62v5.618",
    transform: "translate(-111.304 -257.154)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M481.862,488.442h-5.62v-5.618h5.62v5.618",
    transform: "translate(-111.304 -376.672)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M481.862,630.454h-5.62v-5.618h5.62v5.618",
    transform: "translate(-111.304 -505.931)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M577.185,360.921h-16.8v-1.382h16.8v1.382",
    transform: "translate(-187.893 -264.457)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M577.185,492.33h-16.8v-1.377h16.8v1.377",
    transform: "translate(-187.893 -384.071)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M577.185,634.245h-16.8v-1.381h16.8v1.381",
    transform: "translate(-187.893 -513.238)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M501.467,743.117c1.174-.023,2.334-.014,3.5-.014v1.257c-1.562,0-3.087.014-4.612,0a.843.843,0,0,1-.809-.462c-.3-.545-.6-1.091-.91-1.631-.319-.582-.647-1.16-1.017-1.811-.083.152-.129.226-.166.3q-1.893,3.548-3.785,7.1a.938.938,0,0,1-.98.605.841.841,0,0,1-.887-.675c-1.1-3.054-2.213-6.117-3.313-9.167a.4.4,0,0,0-.189-.272c-.092.166-.176.3-.273.448-.971,1.631-1.95,3.266-2.921,4.9a.9.9,0,0,1-.8.522c-1.553.009-3.092,0-4.663,0v-1.257c1.174,0,2.306-.023,3.429.014a.761.761,0,0,0,.818-.416c1.243-2.116,2.518-4.223,3.776-6.339a.954.954,0,0,1,.971-.508.843.843,0,0,1,.836.628q1.546,4.29,3.1,8.562a2.2,2.2,0,0,0,.356.8c.092-.166.176-.3.259-.462,1.16-2.176,2.334-4.362,3.489-6.538a.455.455,0,0,0,.037-.083.907.907,0,0,1,.9-.522.918.918,0,0,1,.873.508c.767,1.4,1.562,2.791,2.329,4.186.134.24.273.333.652.333",
    transform: "translate(-114.398 -606.84)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M560.387,663.941h22.445v1.381H560.387v-1.381",
    transform: "translate(-187.893 -541.525)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M582.925,392H560.387v-1.382h22.538V392",
    transform: "translate(-187.893 -292.744)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M582.925,523.454H560.387v-1.372h22.538v1.372",
    transform: "translate(-187.893 -412.404)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M767.887,490.953h10.768v1.377H767.887v-1.377",
    transform: "translate(-376.76 -384.071)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M768.145,632.863h12.967v1.381H768.145v-1.381",
    transform: "translate(-376.995 -513.238)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M782.66,359.539v1.382H768.3v-1.382H782.66",
    transform: "translate(-377.133 -264.457)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M919.613,182.068V226.41a15.268,15.268,0,0,0-5.194-1.252V185.973a1.3,1.3,0,0,0-1.3-1.3h-6.326v-5.216h10.218a2.605,2.605,0,0,1,2.606,2.615",
    transform: "translate(-503.189 -100.542)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(353.957 78.87)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M395.146,252.348H356.309a2.6,2.6,0,0,1-2.6-2.6V182.068a2.6,2.6,0,0,1,2.6-2.615h10.222v5.216h-6.308a1.3,1.3,0,0,0-1.3,1.3v59.871a1.3,1.3,0,0,0,1.3,1.3h32.487a14.912,14.912,0,0,0,2.435,5.2",
    transform: "translate(-353.729 -179.412)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M537.631,76.31a3.305,3.305,0,0,1-6.581,0c-.009-.106-.009-.226-.009-.342a3.307,3.307,0,0,1,6.613.023C537.654,76.1,537.64,76.2,537.631,76.31Zm4.46-.342c-.023-.286-.037-.5-.06-.711-.319-3.086-2.269-5.558-4.8-6.03a17.942,17.942,0,0,0-5.217-.088,5.518,5.518,0,0,0-4.261,2.828,8.462,8.462,0,0,0-1.169,4.062h-8.757v10.95h33.01V75.968h-8.743",
    transform: "translate(-149.152)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M517.829,184.711V179.5h0v5.207h0",
    transform: "translate(-149.152 -100.588)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M481.862,351.516v5.618h-5.62v-5.618h5.62",
    transform: "translate(-111.304 -257.154)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M577.185,359.539v1.382h-16.8v-1.382h16.8",
    transform: "translate(-187.893 -264.457)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M582.925,390.617V392H560.387v-1.382h22.538",
    transform: "translate(-187.893 -292.744)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M782.66,359.539v1.382H768.3v-1.382H782.66",
    transform: "translate(-377.133 -264.457)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M481.862,482.824v5.618h-5.62v-5.618h5.62",
    transform: "translate(-111.304 -376.672)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M577.185,490.953v1.377h-16.8v-1.377h16.8",
    transform: "translate(-187.893 -384.071)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M582.925,522.082v1.372H560.387v-1.372h22.538",
    transform: "translate(-187.893 -412.404)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M778.654,490.953v1.377H767.887v-1.377h10.768",
    transform: "translate(-376.76 -384.071)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M481.862,624.836v5.618h-5.62v-5.618h5.62",
    transform: "translate(-111.304 -505.931)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M577.185,632.863v1.381h-16.8v-1.381h16.8",
    transform: "translate(-187.893 -513.238)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M582.832,663.941v1.381H560.387v-1.381h22.445",
    transform: "translate(-187.893 -541.525)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M781.112,632.863v1.381H768.145v-1.381h12.967",
    transform: "translate(-376.995 -513.238)",
    fill: "#006297"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.8f29926944aaaeca557330a03aa809b6.svg";
export { ForwardRef as ReactComponent };